var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52876 5.52876C3.78911 5.26841 4.21122 5.26841 4.47157 5.52876L8.00016 9.05735L11.5288 5.52876C11.7891 5.26841 12.2112 5.26841 12.4716 5.52876C12.7319 5.78911 12.7319 6.21122 12.4716 6.47157L8.47157 10.4716C8.21122 10.7319 7.78911 10.7319 7.52876 10.4716L3.52876 6.47157C3.26841 6.21122 3.26841 5.78911 3.52876 5.52876Z",
    fill: "#495057"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.30b7eac9f3c5fcaca125b4937898669b.svg";
export { ForwardRef as ReactComponent };